import ScrollReveal from 'scrollreveal'
//ScrollReveal().reveal('.home-slider', { easing: 'ease-in', delay: 300, duration: 600 });

if ($(window).width() > 991) {
  
ScrollReveal().reveal('.knowledge-cards', { easing: 'ease-in', delay: 300, duration: 600 });
ScrollReveal().reveal('.knowledge-cards .card', { easing: 'ease', delay: 200, duration: 800, distance: '10px' });

}
